module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki04_sp-47eb75be122f4f1a1ff41c4f78d1b66c.jpg";